import { jsx as _jsx } from "react/jsx-runtime";
function GridCellFunction(props) {
    const dataValue = (props.formattingFn
        ? props.formattingFn(props.data[props.dataKey])
        : props.data[props.dataKey]) || '-';
    return props.as === 'th' ? (_jsx("th", Object.assign({ scope: "row", className: props.className }, { children: dataValue.toString() }))) : (_jsx("td", Object.assign({ className: props.className }, { children: dataValue.toString() })));
}
export const GridCell = GridCellFunction;
